
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/limousine",
      function () {
        return require("private-next-pages/investments/limousine.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/limousine"])
      });
    }
  